var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPinIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1999 6.80002C13.1999 10.7944 8.7687 14.9544 7.2807 16.2392C7.14208 16.3435 6.97334 16.3998 6.7999 16.3998C6.62646 16.3998 6.45772 16.3435 6.3191 16.2392C4.8311 14.9544 0.399902 10.7944 0.399902 6.80002C0.399902 5.10264 1.07419 3.47477 2.27442 2.27454C3.47465 1.07431 5.10252 0.400024 6.7999 0.400024C8.49729 0.400024 10.1252 1.07431 11.3254 2.27454C12.5256 3.47477 13.1999 5.10264 13.1999 6.80002Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7999 9.20002C8.12539 9.20002 9.1999 8.12551 9.1999 6.80002C9.1999 5.47454 8.12539 4.40002 6.7999 4.40002C5.47442 4.40002 4.3999 5.47454 4.3999 6.80002C4.3999 8.12551 5.47442 9.20002 6.7999 9.20002Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinIconBlack);
export default __webpack_public_path__ + "static/media/map-pinIconBlack.e35c03a75da99404a7956d5286168886.svg";
export { ForwardRef as ReactComponent };